function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ----------------------------------------------------------------------------
// Feature Detection
// ----------------------------------------------------------------------------
//
// Docs: https://www.notion.so/iTF-Feature-Detection-cf1e905ae2d14c0b9ae3b161b4898af8
//
// ----------------------------------------------------------------------------

class FeatureDetect {
  static addTest(name, test) {
    var className = "".concat(name);
    var notClassName = "no-".concat(name);

    // Run the test
    var isSupported = !!test();

    // Update the class names based on the test result
    document.documentElement.classList.remove(isSupported ? notClassName : className);
    document.documentElement.classList.add(isSupported ? className : notClassName);

    // Save the test result
    this.results[name] = isSupported;
  }
  static supports(name) {
    return this.results[name] || false;
  }
}

// -------------------------------------
// Detect Cookie Support and add a Class
// -------------------------------------
_defineProperty(FeatureDetect, "results", {});
FeatureDetect.addTest('cookies', () => {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled) {
    document.cookie = 'testcookie=1; max-age=5';
    cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
  }
  return cookieEnabled;
});